"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const tools_1 = require("./tools");
const errors_1 = require("./errors");
class GraphQLClientImpl {
    constructor(graphqlEndpoint, timeoutInMsec) {
        this.graphqlEndpoint = graphqlEndpoint;
        this.timeoutInMsec = timeoutInMsec;
    }
    executeRequest(query, variables) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const authRequest = {
                query: query,
                variables: variables,
                operationName: null,
            };
            const res = yield tools_1.promiseTimeout(this.timeoutInMsec, fetch(this.graphqlEndpoint, {
                method: 'POST',
                credentials: 'omit',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8',
                },
                body: JSON.stringify(authRequest),
            }));
            if (!(res.status >= 200 && res.status <= 300)) {
                throw new errors_1.AuthError(errors_1.AuthErrorCode.NETWORK, `Response status is invalid: ${res.status}`);
            }
            const contentType = res.headers.get('content-type');
            if ((contentType === null || contentType === void 0 ? void 0 : contentType.includes('application/json')) !== true) {
                throw new errors_1.AuthError(errors_1.AuthErrorCode.NETWORK, `Invalid response content type: ${contentType}`);
            }
            const result = yield res.json();
            if (((_a = result.errors) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                // TODO parse error code, check for BAD_CREDENTIALS
                throw new errors_1.AuthError(errors_1.AuthErrorCode.BAD_CREDENTIALS, 'There is an error in response: ' + result.errors[0].message);
            }
            return result.data;
        });
    }
}
exports.default = GraphQLClientImpl;
